import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MenuComponent } from '../MenuComponent';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';

export class LH_LoadOpenASN extends Component {
    static displayName = LH_LoadOpenASN.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            openASN: [],
            selectedContainerRef:""
        }
    }

    componentDidMount() {
        this.loadOpenASN();

    }

    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }

    async loadOpenASN() {
        this.state.loading = true;

      
        fetch(`api/LinenhouseXdoc/GetOpenASN`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ openASN: [], alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ openASN: data, alertMessage: "" });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load ASN containers!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load ASN containers!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ openASN: [], alertMessage: error });
            });
    }

    selectASN(selectedRow) {

        this.state.loading = true;
        this.state.selectedContainerRef = selectedRow.containerref;
        fetch(`api/LinenhouseXdoc/HasArrayBeenCreated?containerRef=${selectedRow.containerref}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            if (data.length > 0) {
                                this.goto('../LinenhouseXdoc/LH_PutArray');
                            }
                            else {
                                this.goto('../LinenhouseXdoc/LH_Rows');
                            }
                           
                        }
                        else {
                            //TODO: Check with Bruce about the wording of this message
                            this.setState({ alertMessage: "Failed to check if Array has been created!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to check if Array has been created!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }


    render() {



        let openASNHtml = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderOpenASN();

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h4>Select Container</h4></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('../Inwards'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                   
                    <Row>
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {openASNHtml}
                            </div>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('../LinenhouseXdoc/LH_DecantPallet'); }} >Decant Pallet</button>
                        </Col>
                    </Row>
                </Container>
            </div>

        );
    }

    renderOpenASN() {

        return (
            <div>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead style={{ position: 'sticky', top: -2, background: 'white' }}>
                        <tr>
                            <th className="col-sm-4">
                                <label>Container No</label>
                                <br />
                                <input className="col-sm-4" ref="containerRefInput" value={this.state.selectedContainerRef} onChange={(e) => { this.setState({ selectedContainerRef: e.target.value }); }} />
                            </th>
                            

                        </tr>
                    </thead>
                    <tbody>
                        {this.state.openASN
                            .filter((item) =>
                                (!this.state.selectedContainerRef.length ||
                                    item.containerref
                                        .toString()
                                        .toLowerCase()
                                .includes(this.state.selectedContainerRef.toString().toLowerCase()))).map(row =>
                                    <tr key={row.containerref} onClick={() => { this.selectASN(row) }}>
                                        <td>{row.containerref}</td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
        );
    }
}